import { Component, Children } from 'react';
import { ProviderFactory } from 'fela-bindings';
import PropTypes from 'prop-types';

export default ProviderFactory(Component, function (children) {
  return Children.only(children);
}, {
  propTypes: {
    renderer: PropTypes.object.isRequired,
    rehydrate: PropTypes.bool.isRequired
  },
  childContextTypes: {
    renderer: PropTypes.object
  },
  defaultProps: {
    renderToDOM: true,
    rehydrate: true
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/react-fela/es/Provider.js
// module id = 1193
// module chunks = 0